const accTitles = document.querySelectorAll(".accordion-Title");

accTitles.forEach((title) => {
  title.addEventListener("click", function() {
    if(this.parentNode.classList.contains('active')) {
      this.parentNode.classList.remove('active');
      this.nextSibling.nextElementSibling.style.height = `0px`;
    } else {
      accTitles.forEach((titles) => {
        titles.parentNode.classList.remove('active');
        titles.nextElementSibling.style.height = `0px`;
      })
      this.parentNode.classList.add('active');
      const height = this.nextElementSibling.children[0].offsetHeight;
      const realHeight = height+10;
      this.nextSibling.nextElementSibling.style.height = `${realHeight}px`;
    }
  })
})